import { getCurrentInstance as i, inject as e, computed as c, unref as m, ref as l } from "vue";
import { isNumber as p } from "./index565.js";
import { debugWarn as v } from "./index588.js";
import { isClient as Z } from "./index599.js";
const s = {
  current: 0
}, u = l(0), f = 2e3, d = /* @__PURE__ */ Symbol("elZIndexContextKey"), y = /* @__PURE__ */ Symbol("zIndexContextKey"), E = (I) => {
  const n = i() ? e(d, s) : s, x = I || (i() ? e(y, void 0) : void 0), t = c(() => {
    const r = m(x);
    return p(r) ? r : f;
  }), o = c(() => t.value + u.value), a = () => (n.current++, u.value = n.current, o.value);
  return !Z && !e(d) && v(
    "ZIndexInjection",
    `Looks like you are using server rendering, you must provide a z-index provider to ensure the hydration process to be succeed
usage: app.provide(ZINDEX_INJECTION_KEY, { current: 0 })`
  ), {
    initialZIndex: t,
    currentZIndex: o,
    nextZIndex: a
  };
};
export {
  d as ZINDEX_INJECTION_KEY,
  f as defaultInitialZIndex,
  E as useZIndex,
  y as zIndexContextKey
};
